// extracted by mini-css-extract-plugin
module.exports = {"icon":"copy-link-button_icon__a8bdN","button":"copy-link-button_button__1G458"};